export default __webpack_public_path__ + "static/media/GreyRegular.24440d25.png";